import type { NormalizedSchema, schema } from 'normalizr';
import { normalize } from 'normalizr';

export const normalizeResponse = <T, I = string[]>(
  responseData: unknown,
  schema: schema.Entity<unknown>[] | schema.Entity<unknown>,
): NormalizedSchema<T, I> => {
  return normalize(responseData, schema);
};
